import { Swiper} from "swiper/bundle";
import selectors from '../../scripts/constants';
export default class CarouselSingle {
    constructor() {
        // console.log('carousel-quote', this.carousel);
        this.carousel = document.querySelectorAll(selectors.carouselQuote)
    }
    init() {
        this.carousel.forEach((elem, i) => {

            new Swiper(elem, {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 30,
                loop: true,
                centeredSlides: true,
                pagination: {
                  el: selectors.carouselPagination,
                  type: "bullets",
                  clickable: true,
                },
                navigation: {
                  prevEl: elem.parentElement.querySelector(selectors.carouselPrev),
                  nextEl: elem.parentElement.querySelector(selectors.carouselNext),
                },
                breakpoints: {
                    768: {
                        slidesPerView:  1.2,
                        centeredSlides: false,
                    }
                }

            });
        })
    }
}